import { render, staticRenderFns } from "./advertisement.vue?vue&type=template&id=113bb09f&scoped=true&"
import script from "./advertisement.vue?vue&type=script&lang=ts&"
export * from "./advertisement.vue?vue&type=script&lang=ts&"
import style0 from "./advertisement.vue?vue&type=style&index=0&id=113bb09f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113bb09f",
  null
  
)

export default component.exports